import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
    View, Image, Text, StyleSheet,
    Linking, TouchableOpacity, ScrollView
} from "react-native"
import { MaterialIcons } from '@expo/vector-icons';
import { doPost, doPostGuest } from '../../utils/services/api/API';
import * as CommonUtils from "../../utils/services/CommonUtils";
import * as ScreenShimmer from "../shimmer-component/ScreenShimmer";
import { updateReduxAayuCardAllPlans, updateReduxAayuCardPlans, updateReduxPremiumAayuCard } from '../../utils/services/redux/commonRedux';
import { CarouselAayuCardDesign } from '../../utils/widgets/AayuCard/AayuCardDesign';
import AayuCardBenifits from "../../utils/widgets/AayuCard/AayuCardBenifits";
import FaqsComponent from "../../utils/widgets/FaqsComponent";
import { CommonAayuText } from "../../utils/widgets/CommonAayuLogo";
import AppTheme from '../../AppTheme';
import { triggerFBQ } from '../../utils/services/CommonUtils';
import { debounce } from "lodash";
import * as MoengageUtils from "../../utils/services/webapp-services/MoengageUtils";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import AppStyles from '../../AppStyles';
import { fbqEventName } from '../../utils/constants/fbqEventName';
import { store } from "../../store/store";
import { AayuCardVideoURL, Ampersand } from '../../utils/constants/AppConstants';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { selectedAayuCardForPurcahseSubscription } from '../../utils/services/subject-behaviour/CommonRxjsService';
// import RecapchaComponent, { onSubmitWithReCAPTCHA } from '../../utils/widgets/RecaptchaComponent';

const PrePurchaseAayuCard = (props) => {

    const reduxState = store.getState()
    const [aayucardPlans, updatePlans] = useState([]);
    const [reviews, updateReviews] = useState([]);
    const [hasCalledConfigAPI, updateConfigAPICalled] = useState(false)
    const [render, updateRenderState] = useState(false);

    let rcbElementRef = useRef(null)

    const getAayuCardPlans = () => {
        var params = { 'ln': 'en' };
        reduxState.isUserLogin ?
            doPost('service_config/get_configurations', params).then(
                (response: any) => {
                    if (response == null || response.status == 401) {
                        setTimeout(() => {
                            props.navigation.popToTop();
                            props.navigation.replace('splash')
                        }, (500));
                    } else {
                        let plans: any = response.plans.filter(item => item.canPurchase === true)
                        updatePlans(plans);
                        updateReviews(response.reviews);
                        updateReduxAayuCardPlans(plans);
                        updateReduxPremiumAayuCard(plans[0]);
                        updateReduxAayuCardAllPlans(response.plans);
                        updateConfigAPICalled(true)
                        updateRenderState(true);
                    }
                }
            ) : doPostGuest('service_config/get_configurations', params).then(
                (response: any) => {
                    if (response == null || response.status == 401) {
                        setTimeout(() => {
                            props.navigation.popToTop();
                            props.navigation.replace('splash')
                        }, (500));
                    } else {
                        let plans: any = response.plans.filter(item => item.canPurchase === true)
                        updatePlans(plans);
                        updateReviews(response.reviews);
                        updateReduxAayuCardPlans(plans);
                        updateReduxPremiumAayuCard(plans[0]);
                        updateReduxAayuCardAllPlans(response.plans);
                        updateConfigAPICalled(true)
                        updateRenderState(true);
                    }
                }
            )
    }

    const getAayuCardPlansCallBack = useCallback(debounce(() => getAayuCardPlans(), 300), [])

    useEffect(() => {
        const reduxState = store.getState()

        if (reduxState.isUserLogin || CommonUtils.isGuestTokenValid()) {
            getAayuCardPlansCallBack()
        } else {
            // onSubmitWithReCAPTCHA(rcbElementRef, {
            //     actionToPerform: () => getAayuCardPlansCallBack()
            // })
        }
        if (hasCalledConfigAPI)
            updateRenderState(true);
    }, [])

    function onActivateClick(plan) {
        MoengageUtils.trackMoengageEvents('aayu_card_purchase_clicked');
        triggerFBQ(fbqEventName.onClick, {
            'plan_id': plan.plan,
            'plan_price': plan.discountedPrice,
        });
        if (reduxState.isUserLogin) {
            if (reduxState.userDetails['isProfileComplete']) {
                props.navigation.navigate(ScreenRoute.payment_online, { serviceParams: plan, serviceName: 'Aayu Card Subscription' });
            } else {
                selectedAayuCardForPurcahseSubscription.setSelectedAayuCard({ serviceParams: plan, serviceName: 'Aayu Card Subscription' })
                props.navigation.navigate(ScreenRoute.complete_profile,
                    { isGeneralFlow: true })
            }
        } else {
            selectedAayuCardForPurcahseSubscription.setSelectedAayuCard({ serviceParams: plan, serviceName: 'Aayu Card Subscription' })
            global.navigateFrom = NavigateFrom.acs_plans
            props.navigation.navigate(ScreenRoute.login);
        }
    }

    return (
        <View style={{ flex: 1, width: AppTheme.appWidth }}>

            <CommonHeader navigation={props.navigation} title='Aayu Card' />

            <View style={{ width: AppTheme.appWidth, margin: 'auto', marginTop: AppTheme.headerHeight }}>
                {
                    render ? <ScrollView style={{ backgroundColor: AppTheme.color.white }} showsVerticalScrollIndicator={false}>

                        {/* <Animatable.View animation="fadeIn"
                            duration={3000}
                            delay={0}
                            useNativeDriver>
                            <ImageBannerCorousel/>
                        </Animatable.View> */}

                        <TouchableOpacity onPress={() => {
                            Linking.openURL(AayuCardVideoURL).catch((err) =>
                                console.error('An error occured', err));
                        }}> <View style={[AppStyles.flexRowCenter, { padding: 24, justifyContent: 'space-between', backgroundColor: AppTheme.color.purple.text }]}>
                                <View style={{ width: AppTheme.appWidth * 0.65 }}>
                                    <Text style={styles.saveText}>
                                        Save your family’s expenses for 12 months</Text>
                                    <View style={[AppStyles.flexRowCenter, { alignItems: "center" }]}>
                                        <Image source={{
                                            uri: CommonUtils.getImagePath(
                                                '/images/aayuCard/aayu_card_video_button.svg'),
                                            height: 36, width: 36
                                        }}
                                            style={{ marginRight: 12 }} />
                                        <Text style={styles.watchText}>
                                            Watch video to know more!</Text>
                                    </View>
                                </View>
                                <Image source={{
                                    uri: CommonUtils.getImagePath(
                                        '/images/aayuCard/aayu_card_family.svg'),
                                    height: 100, width: 90
                                }}
                                    style={{ paddingBottom: 4, }} />
                            </View>
                        </TouchableOpacity>

                        <View style={{ marginHorizontal: 20, marginTop: 24, paddingBottom: 8 }}>
                            <Text style={[{ fontSize: 20, lineHeight: 21 }]}>Available Plans</Text>
                        </View>

                        <View style={{ alignSelf: "center", alignContent: "center", marginVertical: 8 }}>

                            <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={{ paddingBottom: 4 }}>
                                {
                                    aayucardPlans.map((plan, index) => (
                                        <TouchableOpacity key={index} style={{ marginLeft: 16 }}
                                            onPress={() => { onActivateClick(plan) }}>
                                            <CarouselAayuCardDesign aayuCardPlan={plan} />
                                        </TouchableOpacity>
                                    ))
                                }
                            </ScrollView>
                        </View>

                        <TouchableOpacity onPress={() => { props.navigation.navigate(ScreenRoute.acs_quiz) }}
                            style={[AppStyles.flexRow, { paddingLeft: 22, backgroundColor: AppTheme.color.blue.bg }]}>
                            <Image source={{
                                uri: CommonUtils.getImagePath('/images/aayuCard/aayu_card_quiz.svg'),
                                height: 82, width: 82
                            }} />
                            <View style={{ marginLeft: 16 }}>
                                <Text style={[AppStyles.f16, {
                                    flexWrap: "wrap",
                                    width: AppTheme.appWidth * 0.60, marginBottom: 8,
                                    color: AppTheme.color.blue.darkBlue
                                }]}>Want to know the best plan for your family?</Text>
                                <View style={AppStyles.flexRow}>
                                    <Text style={[AppStyles.f14, { color: AppTheme.color.primary }]}>Take a short quiz {Ampersand} find out!</Text>
                                    <MaterialIcons name="chevron-right" style={{
                                        borderRadius: 50, marginLeft: 8, paddingHorizontal: 2,
                                        backgroundColor: AppTheme.color.primary
                                    }} size={15} color={AppTheme.color.white} />
                                </View>
                            </View>
                        </TouchableOpacity>

                        <View style={{
                            marginBottom: 4, marginTop: 16, marginHorizontal: 16, paddingHorizontal: 24, paddingVertical: 12, borderRadius: 4,
                            alignContent: "center", justifyContent: "center", alignItems: "center", zIndex: 1, shadowOpacity: 0.3, shadowRadius: 5, shadowOffset: { height: 1, width: 1 }
                        }}>
                            <AayuCardBenifits /></View>

                        <FaqsComponent {...{ faqsPage: 'AayuFAQs' }} />

                    </ScrollView> : <View>
                        <ScreenShimmer.PrePurchanseShimmer />
                        <FaqsComponent {...{ faqsPage: 'AayuFAQs' }} />
                        <CommonAayuText />
                    </View>
                }
                {/* <RecapchaComponent ref={rcbElementRef} /> */}

            </View>
        </View>
    )
}

export default PrePurchaseAayuCard;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    saveExpense: { width: 180, marginLeft: 7, color: AppTheme.color.white, fontWeight: 600 },
    saveText: { fontSize: 20, color: AppTheme.color.white, marginBottom: 24, width: AppTheme.appWidth * 0.65, flexWrap: 'wrap' },
    watchText: { fontSize: 16, color: AppTheme.color.white, width: innerWidth * 0.45, flexWrap: 'wrap' },
}))
